import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_WIDTH = 8;
const DEFAULT_HEIGHT = 8;

function IconStoryGroup({ width, color }: Omit<IconProps, "height" | "class">) {
    const height = width! * DEFAULT_HEIGHT / DEFAULT_WIDTH;

    return (
        <svg width={width} height={height} viewBox="0 0 8 8">
            <path d="M4 1H.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4l-.008-.09A.5.5 0 0 0 7.5 2H5.206l-.852-.854A.5.5 0 0 0 4 1zm-.208 1 .854.854.06.05A.5.5 0 0 0 5 3h2v3H1V2h2.792z" fill={color} fill-rule="nonzero"/>
        </svg>
    );
}

IconStoryGroup.defaultProps = {
    width: DEFAULT_WIDTH,
    color: "var(--gandalf)"
};

export default IconStoryGroup;
